import Step1 from '../assets/images/steps/Step-1.svg';
import Step2 from '../assets/images/steps/Step-2.svg';
import Step3 from '../assets/images/steps/Step-3.svg';
import Step4 from '../assets/images/steps/Step-4.svg';
import Step5 from '../assets/images/steps/Step-5.svg';
import Step6 from '../assets/images/steps/Step-6.svg';
import Step7 from '../assets/images/steps/Step-7.svg';
import Step8 from '../assets/images/steps/Step-8.svg';
import Step9 from '../assets/images/steps/Step-9.svg';

export default [
  {
    slideData: [
      {
        step: 1,
        text: 'Search for Screenapp.io on your chrome or firefox browser.',
        image: Step1,
      },
      {
        step: 2,
        text:
          'Click on the “Sign up” button for a FREE subscription plan or sign up for Standard/Premium accounts.',
        image: Step2,
      },
      {
        step: 3,
        text:
          'Choose to create an account with Google account, Facebook account or Email and password.',
        image: Step3,
      },
    ],
  },
  {
    slideData: [
      {
        step: 4,
        text: 'Once you enter your dashboard, click on “New Recording“',
        image: Step4,
      },
      {
        step: 5,
        text: 'Choose one from the audio options given',
        image: Step5,
      },
      {
        step: 6,
        text:
          'Choose to share from the options given and click on “Share your screen”',
        image: Step6,
      },
    ],
  },
  {
    slideData: [
      {
        step: 7,
        text: 'Click on “Start Recording”',
        image: Step7,
      },
      {
        step: 8,
        text:
          'Once you are done with your recording, click on “Stop Recording”',
        image: Step8,
      },
      {
        step: 9,
        text:
          'Your screen recording file will be available for immediate download. Click “download” for direct download or view the recording in your library.',
        image: Step9,
      },
    ],
  },
];
